import OMath from "./OMath";

export default class OPoint extends PIXI.Point {
    constructor(x = 0, y = 0) {
        super(x, y);
    }

    /**
     * @param {OPoint} p
     * @returns {OPoint}
     */
    copyFrom(p) {
        this.x = p.x;
        this.y = p.y;
        return this;
    }

    /**
     * @param {OPoint} p
     * @returns {OPoint}
     */
    multiplyPoint(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    }

    /**
     * @param {Number} value
     * @returns {OPoint}
     */
    multiply(value) {
        this.x *= value;
        this.y *= value;
        return this;
    }

    /**
     * @param {OPoint} p
     * @returns {OPoint}
     */
    dividePoint(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    }

    /**
     * @param {Number} value
     * @returns {OPoint}
     */
    divide(value) {
        this.x /= value;
        this.y /= value;
        return this;
    }

    get length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }

    /**
     * @param {Number} aX
     * @param {Number} aY
     * @param {Number} aDiff
     * @return        {boolean}
     */
    equal(aX, aY, aDiff = 0.000001) {
        return (OMath.equal(this.x, aX, aDiff) && OMath.equal(this.y, aY, aDiff));
    }

    /**
     * @param    {OPoint} p
     * @param    {Number} aDiff
     * @return        {boolean}
     */
    equalPoint(p, aDiff) {
        aDiff = aDiff || 0.000001;
        return (OMath.equal(this.x, p.x, aDiff) && OMath.equal(this.y, p.y, aDiff));
    }

    toString() {
        return "[OPoint x:" + this.x.toString() + " y:" + this.y.toString() + "]";
    }
}
